require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-a-new-multiturn-dialogue-dataset.json") })
        }
      }, "path---posts-a-new-multiturn-dialogue-dataset");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-a-new-multiturn-dialogue-dataset!./.cache/json/posts-a-new-multiturn-dialogue-dataset.json
// module id = 367
// module chunks = 231608221292675